import type { FaireProductEntity } from "../../entity_types/product";

export const p_vef43k2b3w: FaireProductEntity = {
  token: "p_vef43k2b3w",
  type: "product",
  name: "fern cotton flour sack tea towel",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/a4bd663a7f77dcc4bacefd1545a7d50e48b0771242eae253b7c5a9bc11c1893a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70f889ae742e64e5125a16c378905a248e62372d81f68e8b250e91eece55ee20.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Add a touch of delight to your kitchen with this 100% cotton tea towel. Charming fern illustrations cover the towel making it perfect for washing up, lining a basket, wrapping up treats, or setting out to add seasonal charm to your home.\n\n• 100% cotton flour sack tea towel\n• 19" x 28"\n• Loop for hanging\n• Machine wash and dry\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:12.880Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
